import { render, staticRenderFns } from "./BodegaMenuDevolucion.vue?vue&type=template&id=5316b460&scoped=true"
import script from "./BodegaMenuDevolucion.vue?vue&type=script&lang=js"
export * from "./BodegaMenuDevolucion.vue?vue&type=script&lang=js"
import style0 from "./BodegaMenuDevolucion.vue?vue&type=style&index=0&id=5316b460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5316b460",
  null
  
)

export default component.exports